const modal = {
  overlay: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    opacity: 1,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    position: 'fixed',
    zIndex: 99
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    flexFlow: 'column nowrap',
    width: '95%',
    maxWidth: '980px',
    outline: 'none',
    position: 'relative',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }
};

export default modal;
